import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const NewPackCharacteristicsScreen = ({
  isCharacteristicPage = false,
  handleToReview,
  handleToBrandLinePage
}) => {
  const { sendEvent } = useContext(DataLayerEventContext);
  const containerRef = useRef(null);
  const headContainerRef = useRef(null);
  const buttonContainerRef = useRef(null);
  const scrollTimeoutRef = useRef(null);
  const [showStickyButton, setShowStickyButton] = useState(false);

  useEffect(() => {
    sendEvent('seen_product_content');

    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  const handleScroll = (e) => {
    if (headContainerRef.current) {
      const threshold =
        headContainerRef.current.offsetTop +
        headContainerRef.current.offsetHeight * 0.75;
      const isBottom =
        e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 50;

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      if (e.target.scrollTop > threshold) {
        setShowStickyButton(true);

        if (!isBottom) {
          scrollTimeoutRef.current = setTimeout(() => {
            setShowStickyButton(false);
          }, 3000);
        }
      } else {
        setShowStickyButton(false);
      }
    }
  };

  const handleScrollToBuy = () => {
    if (containerRef.current && buttonContainerRef.current) {
      containerRef.current.scrollTo({
        top: buttonContainerRef.current.offsetTop - 10,
        behavior: 'smooth'
      });
    }
  };

  const handleToSignatureLanding = () => {
    window.location.href = '/ua-prl?utm_campaign=26UA-PRL-Sign';
  };

  return (
    <div
      className={styles.container}
      ref={containerRef}
      onScroll={handleScroll}
    >
      <div
        className={styles.questionButton}
        onClick={() =>
          window.open(
            'https://t.me/pmu_support_bot?start=ScnPck-26UA-PRL-S',
            '_blank'
          )
        }
      >
        <p>Є питання?</p>
        <svg
          width="27"
          height="24"
          viewBox="0 0 27 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.86207 0C0.837931 0 0 0.929593 0 2.06576V18.5919L2.7931 15.4932H20.4828C21.5069 15.4932 22.3448 14.5636 22.3448 13.4275V2.06576C22.3448 0.929593 21.5069 0 20.4828 0H1.86207ZM23.2759 8.26305V13.4275C23.2759 15.1833 22.0655 16.5261 20.4828 16.5261H13.0345V18.5919C13.0345 19.728 13.8724 20.6576 14.8966 20.6576H24.2069L27 23.7563V10.3288C27 9.19264 26.1621 8.26305 25.1379 8.26305H23.2759Z"
            fill="white"
          />
        </svg>
      </div>
      {!isCharacteristicPage && (
        <div
          className={`${styles.stickyButton} ${showStickyButton ? styles.visible : ''}`}
          onClick={handleToReview}
        >
          <p>Залишити відгук</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
          >
            <circle
              cx="15"
              cy="15"
              r="15"
              fill="url(#paint0_linear_1864_1348)"
            />
            <path
              d="M13 21L18.6464 15.3536C18.8417 15.1583 18.8417 14.8417 18.6464 14.6464L13 9"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1864_1348"
                x1="15"
                y1="0"
                x2="15"
                y2="30"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#B58560" />
                <stop offset="1" stopColor="#76685F" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.headContainer} ref={headContainerRef}>
          <img
            src={getImageFromS3('images/26ua-prl-s/pack/head-bg.png')}
            alt="head-bg"
          />
          <div className={styles.headContent}>
            <p className={styles.brandTitle}>Parliament</p>
            <p className={styles.lineTitle}>Silver Blue</p>
            <img
              src={getImageFromS3('videos/26ua-prl-s/pack.gif')}
              alt="pack"
            />
          </div>
        </div>
        {!isCharacteristicPage && (
          <div
            className={styles.signatureFab}
            onClick={handleToSignatureLanding}
          >
            <div className={styles.fabViewport}>
              <div className={styles.fab}>
                <img
                  className={styles.fabBg}
                  src="/images/gold-coins-button-bg.png"
                  alt=""
                />
                <img
                  className={styles.fabCoin}
                  src="/images/gold-coins-button-coin.png"
                  alt=""
                />
                <img
                  className={styles.fabSmallBall}
                  src="/images/gold-coins-button-small-ball.png"
                  alt=""
                />
                <img
                  className={styles.fabMediumBall}
                  src="/images/gold-coins-button-medium-ball.png"
                  alt=""
                />
                <img
                  className={styles.fabOpacityBall}
                  src="/images/gold-coins-button-opacity-ball.png"
                  alt=""
                />
                <img
                  className={styles.fabBottomShadow}
                  src="/images/gold-coins-button-bottom-shadow.png"
                  alt=""
                />
                <img
                  className={styles.fabTopShadow}
                  src="/images/gold-coins-button-top-shadow.png"
                  alt=""
                />
                <svg
                  className={styles.fabArrow}
                  viewBox="0 0 38 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.5858 3.58578C20.3668 2.80474 21.6332 2.80474 22.4142 3.58578L34.4142 15.5858C35.1953 16.3668 35.1953 17.6332 34.4142 18.4142L22.4142 30.4142C21.6332 31.1953 20.3668 31.1953 19.5858 30.4142C18.8047 29.6332 18.8047 28.3668 19.5858 27.5858L28.1716 19H4.99998C3.89541 19 3 18.1046 3 17C3 15.8954 3.89541 15 4.99998 15H28.1716L19.5858 6.41422C18.8047 5.63317 18.8047 4.36683 19.5858 3.58578Z"
                    fill="white"
                  />
                  <path
                    d="M18.5254 2.52539C19.8922 1.15858 22.1078 1.15855 23.4746 2.52539L35.4746 14.5254C36.8414 15.8922 36.8414 18.1078 35.4746 19.4746L23.4746 31.4746C22.1078 32.8414 19.8922 32.8414 18.5254 31.4746C17.1586 30.1078 17.1586 27.8922 18.5254 26.5254L24.5508 20.5H5C3.067 20.5 1.5 18.933 1.5 17C1.5 15.067 3.067 13.5 5 13.5H24.5508L18.5254 7.47461C17.1586 6.10777 17.1586 3.89223 18.5254 2.52539Z"
                    stroke="#9C7D5D"
                    strokeOpacity="0.5"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        )}
        <div className={styles.fullRangeButton} onClick={handleToBrandLinePage}>
          <p>Повний асортимент</p>
          <svg
            width="4"
            height="7"
            viewBox="0 0 4 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 6.5L3.14645 3.85355C3.34171 3.65829 3.34171 3.34171 3.14645 3.14645L0.5 0.5"
              stroke="white"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <div className={styles.whereBuyButton} onClick={handleScrollToBuy}>
          <img
            src={getImageFromS3('images/26ua-prl-s/pack/glass-button.png')}
            alt="glass-button"
          />
          <p>Де купити онлайн</p>
        </div>
        <div className={styles.contentContainer}>
          <p className={styles.contentTitle}>Вміст</p>
          <div className={styles.contentContent}>
            <img
              src={getImageFromS3('images/26ua-prl-s/pack/content.png')}
              alt="content-bg"
            />
            <div className={styles.contentCharacteristic}>
              <p>
                Смол - <b>4 мг</b>
              </p>
              <p>
                Нікотину - <b>0.3 мг</b>
              </p>
            </div>
          </div>
        </div>
        <div className={styles.filterContainer}>
          <p className={styles.filterTitle}>Фільтр</p>
          <p className={styles.filterSubTitle}>
            <b>Оригінальний Recessed™</b> фільтр
          </p>
          <div className={styles.gifContainer}>
            <img
              src={getImageFromS3('images/26ua-prl-s/pack/filter.gif')}
              alt="filter-gif"
              className={styles.gifImage}
            />
            <img
              src={getImageFromS3('images/26ua-prl-s/pack/filter-shadow.png')}
              alt="filter-shadow"
              className={styles.filterShadow}
            />
          </div>
          <p className={styles.filterDescription}>
            Фільтр складається
            <br />
            <b>з 3-х частин:</b>
          </p>
        </div>
        <div className={styles.filterPartsList}>
          <div>
            <p>
              <b>Ацетатна</b>
              <br />
              <br />
              Затримує тверді частинки сигаретного диму
            </p>
            <img
              src={getImageFromS3('images/26ua-prl-s/pack/acetate-filter.png')}
              alt="acetate"
            />
          </div>
          <div>
            <p>
              <b>Вугільна</b>
              <br />
              <br />
              Адсорбує деякі шкідливі частинки
            </p>
            <img
              src={getImageFromS3('images/26ua-prl-s/pack/coal-filter.png')}
              alt="coal"
            />
          </div>
          <div>
            <p>
              <b>Повітряна камера з ущільненою ацетатною стінкою</b>
              <br />
              <br />
              Робить смак більш м’яким та збалансованим
            </p>
            <img
              src={getImageFromS3('images/26ua-prl-s/pack/air-filter.png')}
              alt="air"
            />
          </div>
        </div>
        <div className={styles.formatContainer}>
          <p className={styles.formatTitle}>Формат</p>
          <div className={styles.formatContent}>
            <p>King Size (Кінг сайз)</p>
            <p>
              <b>Кількість сигарет у пачці – 20</b>
            </p>
            <p>
              <b>Кількість пачок у блоці – 10</b>
            </p>
          </div>
        </div>
        {!isCharacteristicPage && (
          <div
            className={styles.signatureButton}
            onClick={handleToSignatureLanding}
          >
            <img src="/images/signature-button.png" alt="signature" />
          </div>
        )}
        <div className={styles.buttonContainer} ref={buttonContainerRef}>
          <img
            src={getImageFromS3('images/26ua-prl-s/pack/button-shadow.png')}
            alt="button-shadow"
            className={styles.buttonShadow}
          />
          <p className={styles.buttonContainerTitle}>
            <b>Актуальний асортимент</b> можна знайти на офіційних онлайн
            сервісах або у роздрібних точках продажу в твоєму місті
          </p>
          <div className={styles.buttonList}>
            <a
              href="https://cig-poshta.in.ua/shop/parliament/?utm_source=SP"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.button}
            >
              <img
                src={getImageFromS3('images/26ua-prl-s/pack/glass-button.png')}
                alt="glass-button"
              />
              <p>Cig-Poshta</p>
            </a>
            <a
              href="https://rozetka.com.ua/ua/sigareti/c4638591/producer=parliament/"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.button}
            >
              <img
                src={getImageFromS3('images/26ua-prl-s/pack/glass-button.png')}
                alt="glass-button"
              />
              <p>Rozetka</p>
            </a>
          </div>
        </div>
        <div className={styles.footer}>
          Куріння викликає серйозні
          <br />
          захворювання та залежність
          <br />
          Дана інформація про <br />
          продукт надається <br />
          відповідно до статті 15 <br />
          Закону України «Про захист <br />
          прав споживачів»
        </div>
      </div>
    </div>
  );
};

export default NewPackCharacteristicsScreen;
